// extracted by mini-css-extract-plugin
module.exports = {"result":"result___v35t6","resultIcon":"resultIcon___36FDT","up":"up___3Tofy","down":"down___2JcZ9","result-text":"result-text___cUvoH"};